import { render, staticRenderFns } from "./CreateEditDiscount.vue?vue&type=template&id=a8bdc50c"
import script from "./CreateEditDiscount.vue?vue&type=script&lang=js"
export * from "./CreateEditDiscount.vue?vue&type=script&lang=js"
import style0 from "./CreateEditDiscount.vue?vue&type=style&index=0&id=a8bdc50c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports